module.exports = __webpack_public_path__ + "img/fondo.c39a558e.png";